import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b290fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("创建平台")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("平台列表")
const _hoisted_4 = { class: "cellStaff" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cellStaff" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("主账号")
const _hoisted_11 = { class: "d-flex align-items-center mb-20" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-10" }, "状态:", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("有效")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-10" }, "状态:", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("有效")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_19 = {
  key: 0,
  class: "mr-10 ml-10"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-10" }, "权限:", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("销售")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("PM")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("研发")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("CEO")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("语言")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("工程")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("后台")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("确定 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("编辑")

import {ref, reactive, onMounted, computed} from 'vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import store from '@/store/index'
import _ from 'lodash'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/sso/account/list': fetchList,
  // 获取账号权限详情
  'POST/sso/account/permissions': accountPermissionsApi,
  // 更新用户平台权限
  'POST/sso/update_platform_account_permissions': updatePermissionsApi,
  // 创建编辑平台
  'POST/sso/platform': platformApi,
  // 获取所有平台
  'GET/sso/platforms': getPlatformsListApi,
  // 获取员工基本信息
  'GET/users/{id}/profile': usersIdProfileApi,
  // 管理员验证
  'GET/isAdmin': isAdminApi,
  // 获取财务岗位下拉
  'GET/user_finances': financialJobListApi,
  // 批量导入单个平台的多个用户权限
  'POST/sso/batch_import_platform_permissions': importPlatformApi,
  'POST/sso/set_user_status': setSsoUserStatusApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const tbData = computed(() => {
  return MI_tableData.value.map(e => {
    e.platformAccountManages.map(plat => {
      plat.tipStr = plat.permissions.map((e: string) => platformMap[e]).join(',')
      e['plat' + plat.platform] = plat
    })
    return e
  })
})

const searchObj = reactive({
  key: '', alias: '', orgIds: [], staffType: []
})

const searchHandle = () => {
  fetchData({
    ...searchObj,
    staffType: searchObj.staffType.length === 0 ? null : searchObj.staffType
  })
}

const isAdmin = ref<boolean>(false)
const financialJobList = ref([])
onMounted(() => {
  searchHandle()
  getPlatformsList()
  // 判断是否为管理员
  isAdminApi().then((rep: boolean) => {
    isAdmin.value = rep
  })
  // 获取财务岗位
  financialJobListApi().then((rep: any) => {
    financialJobList.value = rep
  })
})

const platformList = ref([])
const getPlatformsList = () => {
  //获取所有平台
  return getPlatformsListApi().then((rep: any) => {
    authForm.value = []
    platformList.value = rep.map((plat: any) => {
      // 修改用户权限
      authForm.value.push({
        email: '',
        platform: plat.platform,
        endDate: '',
        forever: false,
        permissions: []
      })

      // plat.label = plat.platform.toUpperCase().split('_').join(' ')
      plat.label = plat.platform

      return plat
    })
  })
}

// 创建平台
const createdForm = reactive({
  platform: '',
  desc: '',
  id: null,
})
const isShowCreated = ref<boolean>(false)
const isCreateLoad = ref<boolean>(false)
const showCreate = () => {
  createdForm.id = null
  createdForm.desc = ''
  createdForm.platform = ''
  isShowCreated.value = true
}
const submitCreate = () => {
  isCreateLoad.value = true
  platformApi(createdForm).then((rep: any) => {
    ElMessage.success('创建成功')
    isShowCreated.value = false
    searchHandle()
    getPlatformsList()

  }).finally(() => {
    isCreateLoad.value = false
  })
}
// 编辑平台
const isShowPlat = ref<boolean>(false)
const showPlat = () => {
  isShowPlat.value = true
}

const editForm = reactive({
  platform: '',
  desc: '',
  id: '',
})
const isShowEdit = ref<boolean>(false)
const editPlatHandle = (row: any) => {
  Object.assign(editForm, row)
  isShowEdit.value = true
}
const submitEdit = () => {
  isCreateLoad.value = true
  platformApi(editForm).then((rep: any) => {
    ElMessage.success('修改成功')
    searchHandle()
    getPlatformsList()
  }).finally(() => {
    isCreateLoad.value = false
    isShowEdit.value = false
  })
}


// 修改用户平台权限
const authForm: any = ref([])
const isShowAuth = ref<boolean>(false)
const currentUser = reactive<{ user: any }>({user: {}})
const setUserSsoStatus = (enable: boolean) => {
  const user = currentUser.user
  isSubmitLoad.value = true
  setSsoUserStatusApi({userId: user.userId, enable: enable ? "1" : "0"})
      .then((res: any) => {
        user.ssoEnable = enable;
        showRowAuth(user)
        ElMessage.success("设置成功")
        isSubmitLoad.value = false

      }).catch((e: any) => {
    isSubmitLoad.value = false
    user.ssoEnable = !enable;
    console.log("error", e)
    ElMessage.error(e)
  })
}
const endDateChange = (val: boolean, authObj: any) => {
  // 启用禁用修改日期
  if (val === true) {
    authObj.endDate = ''
  } else {
    authObj.endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
  }
}

let editAuthForm: any = []
const showRowAuth = (row: any) => {
  MI_identify.value = true
  // 获取用户财务岗位
  let jobArr: string[] = []
  usersIdProfileApi({id: row.userId}).then(({financeStationId}: { financeStationId: number }) => {
    jobArr = financialJobList.value.reduce((arr: any[], job: { id: number, name: string }) => {
      if (job.id !== financeStationId) return arr;
      const platValue = Object.keys(platformMap).find(key => platformMap[key] === job.name)
      platValue && arr.push(platValue)
      return arr
    }, [])
    // 搜索权限详情
    return accountPermissionsApi({email: row.email}, {contentType: 'formData'})
  }).then((rep: any) => {
    authForm.value.map((auth: any) => {
      // 先清空
      auth.email = row.email
      auth.endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      auth.forever = false
      auth.permissions = jobArr
      rep.map((e: any) => {
        // 平台为空,默认填充财务岗位
        if (auth.platform !== e.platform) return;
        // 平台不为空
        // 保留原始财务岗位
        // auth.originalPermission = _.cloneDeep(e.permissions)
        if (e.permissions && e.permissions.length > 0) {
          // 有权限,重置财务岗位权限显示
          auth.permissions = e.permissions
        }
        auth.endDate = e.endDate
        // 判断是否是永久有效
        if (e.forever === true) {
          auth.forever = true
          return
        }
        if (e.forever === false && dayjs(e.endDate).isBefore(dayjs().format('YYYY-MM-DD'))) {
          // 如果是禁用日期,日期设置为前一天
          auth.endDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          auth.forever = false
        } else {
          auth.forever = true
        }
      })
    })
    // 后续对比是否有变化
    editAuthForm = _.cloneDeep(authForm.value)

    isShowAuth.value = true
    currentUser.user = row
    console.log("current user", row)
    console.log("current auth", authForm.value)
  }).finally(() => {
    MI_identify.value = false
  })

}

const isSubmitLoad = ref<boolean>(false)
const submitAuth = async (plat: any, index: number) => {
  // 如果不是ccjk邮箱,弹框提示
  if (!authForm.value[index].email.includes('@ccjk.com')) {
    try {
      await ElMessageBox.confirm(`您操作的邮箱是${authForm.value[index].email},非ccjk邮箱，确定操作吗，`, '提示')
    } catch (error) {
      return
    }
  }
  isSubmitLoad.value = true
  let param = _.cloneDeep(authForm.value[index])
  // 只有employee资源
  // if(!store.getters.privileges['other_platform_permission'] && 
  //   !store.getters.privileges['user'] && !isAdmin.value){
  //   param.permissions = _.cloneDeep(authForm.value[index].originalPermission) || []
  // }
  updatePermissionsApi({
    ssoPlatformAccountManageList: [param]
  }).then((rep: any) => {
    // console.log(rep);
    if (rep?.needConfirm === true) {
      ElMessageBox.alert(rep.message, '提示')
      return
    }

    ElMessage.success('更新成功')
  }).finally(() => {
    isSubmitLoad.value = false
  })
}


// ---------------------------------
const platformMap: any = {
  SALES: '销售',
  PM: 'PM',
  RD: '研发',
  CEO: 'CEO',
  LANGUAGE: '语言',
  PROJECT: '工程',
  BACKSTAGE: '后台'
}

const tbPlatformStatu = ({row, column, rowIndex, columnIndex}: any) => {
  if (columnIndex < 7) return '';
  if (!row['plat' + column.property] || dayjs(row['plat' + column.property].endDate).isBefore(dayjs().format('YYYY-MM-DD'))) {
    return 'red-cell'
  } else {
    return 'bull-cell'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "searchEle",
              model: _unref(searchObj),
              "label-width": "auto",
              class: "searchBg",
              inline: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名",
                  prop: "key"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).key,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).key) = $event)),
                      placeholder: "请输入姓名",
                      maxlength: "100",
                      clearable: "",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队",
                  prop: "orgIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: _unref(searchObj).orgIds,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).orgIds) = $event)),
                      filterable: "",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "人员状态",
                  prop: "staffType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).staffType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).staffType) = $event)),
                      placeholder: "请选择人员状态",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "转正",
                          value: "转正"
                        }),
                        _createVNode(_component_el_option, {
                          label: "试用期",
                          value: "试用期"
                        }),
                        _createVNode(_component_el_option, {
                          label: "兼职",
                          value: "兼职"
                        }),
                        _createVNode(_component_el_option, {
                          label: "实习生",
                          value: "实习生"
                        }),
                        _createVNode(_component_el_option, {
                          label: "离职",
                          value: "离职"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (isAdmin.value)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: showCreate
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isAdmin.value)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showPlat()))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(tbData),
      "cell-class-name": tbPlatformStatu,
      onRowDblclick: showRowAuth,
      class: "mt-10",
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "英文名",
          prop: "alias",
          width: "110",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "岗位名称",
          prop: "jobName"
        }),
        _createVNode(_component_el_table_column, {
          label: "入职时间",
          prop: "hiredTime",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "SSO ID",
          prop: "ssoUserName",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "人员状态",
          prop: "staffType",
          width: "100"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformList.value, (plat) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            label: plat.label,
            prop: plat.platform,
            width: "140"
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("div", _hoisted_4, [
                (row['plat' + plat.platform]?.tipStr.length > 0 && _unref(dayjs)().isBefore(row['plat' + plat.platform].endDate))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      content: row['plat' + plat.platform].tipStr,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["label", "prop"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      class: "mt-10",
      total: _unref(MI_total),
      small: "",
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowCreated.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isShowCreated).value = $event)),
      title: '创建平台'
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (isShowCreated.value = false)),
          disabled: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (submitCreate())),
          loading: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(createdForm),
          "label-width": "auto",
          "label-position": "top",
          disabled: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "平台名称:",
              prop: "platform"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(createdForm).platform,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(createdForm).platform) = $event)),
                  placeholder: "请输入平台名称",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述:",
              prop: "desc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(createdForm).desc,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(createdForm).desc) = $event)),
                  type: "textarea",
                  placeholder: "请输入平台描述",
                  clearable: "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowEdit).value = $event)),
      title: '编辑平台'
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (isShowEdit.value = false)),
          disabled: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (submitEdit())),
          loading: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(editForm),
          "label-width": "auto",
          "label-position": "top",
          disabled: isCreateLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "平台名称:",
              prop: "platform"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editForm).platform,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(editForm).platform) = $event)),
                  placeholder: "请输入平台名称",
                  clearable: "",
                  maxlength: "200",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述:",
              prop: "desc"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editForm).desc,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(editForm).desc) = $event)),
                  type: "textarea",
                  placeholder: "请输入平台描述",
                  clearable: "",
                  maxlength: "400"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAuth.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((isShowAuth).value = $event)),
      "close-on-click-modal": isSubmitLoad.value,
      "close-on-press-escape": isSubmitLoad.value,
      "show-close": !isSubmitLoad.value,
      title: '配置其他平台权限',
      width: "1100px",
      onClose: _cache[20] || (_cache[20] = ($event: any) => (searchHandle()))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref: "formRef",
          model: authForm.value,
          "label-width": "auto",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(currentUser).user.ssoEnable,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(currentUser).user.ssoEnable) = $event)),
                onChange: _cache[18] || (_cache[18] = ($event: any) => (setUserSsoStatus($event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    border: "",
                    label: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    border: "",
                    label: false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformList.value, (plat, index) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                label: "",
                prop: plat.platform
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(plat.label), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_radio_group, {
                        disabled: !_unref(currentUser).user.ssoEnable,
                        modelValue: authForm.value[index].forever,
                        "onUpdate:modelValue": ($event: any) => ((authForm.value[index].forever) = $event),
                        onChange: ($event: any) => (endDateChange($event, authForm.value[index]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, {
                            border: "",
                            label: true
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, {
                            border: "",
                            label: false
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]),
                      (authForm.value[index].forever === true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "失效日期:"))
                        : _createCommentVNode("", true),
                      (authForm.value[index].forever === true)
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 1,
                            modelValue: authForm.value[index].endDate,
                            "onUpdate:modelValue": ($event: any) => ((authForm.value[index].endDate) = $event),
                            "value-format": "YYYY-MM-DD",
                            "disabled-date": (time) => time.getTime() < Date.now(),
                            clearable: "",
                            placeholder: "不选长期有效"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled-date"]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: authForm.value[index].permissions,
                      "onUpdate:modelValue": ($event: any) => ((authForm.value[index].permissions) = $event),
                      style: {"display":"inline"},
                      disabled: authForm.value[index].forever === false ||
              (!_ctx.$store.getters.privileges['other_platform_permission'] && 
              !_ctx.$store.getters.privileges['user'] && !isAdmin.value)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "SALES",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "PM",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "RD",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "CEO",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "LANGUAGE",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "PROJECT",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_checkbox, {
                          border: "",
                          label: "BACKSTAGE",
                          disabled: !_unref(currentUser).user.ssoEnable
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: !_unref(currentUser).user.ssoEnable,
                      onClick: ($event: any) => (submitAuth(plat, index)),
                      class: "ml-20 mb-5"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ])
                ]),
                _: 2
              }, 1032, ["prop"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, isSubmitLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "close-on-press-escape", "show-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowPlat.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((isShowPlat).value = $event)),
      title: "所有平台"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: platformList.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "ID",
              prop: "id"
            }),
            _createVNode(_component_el_table_column, {
              label: "平台",
              prop: "platform"
            }),
            _createVNode(_component_el_table_column, {
              label: "平台描述",
              prop: "desc",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (editPlatHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_TheUpBtn, {
                  class: "ml-10",
                  upText: '导入',
                  upFetch: _unref(importPlatformApi),
                  onUpSuccess: _cache[21] || (_cache[21] = ($event: any) => (getPlatformsList())),
                  upParams: {
                platform: row.platform
              }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_alert, {
                      title: "导入文件格式如下",
                      type: "warning",
                      closable: false,
                      class: "mb-10"
                    }),
                    _createVNode(_component_el_table, {
                      data: [{email: 'ta.tan@ccjk.com', role: 'SALES;RD', date: '2025/2/4'}],
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "email",
                          label: "邮箱"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "role",
                          label: "角色，用；隔开"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "date",
                          label: "到期日期（可空表示永久）"
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_divider)
                  ]),
                  _: 2
                }, 1032, ["upFetch", "upParams"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isCreateLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})